

import { gastosApi } from "../../apis";
import { useGastosStore } from "../../stores/ops/gastos";
import Swal from "sweetalert2";




export const gastoXID = async(id) => {
    try {
        const { data } = await gastosApi.get(`/gasto/${id}`);
        return data.data;
    } catch (error) {
        const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
        Swal.fire('Error', errores, 'error');
        return false;
    }
}




export const listadoGastosTodos = async({ page=0, inicio, final }) => {
    try {
        const params = new URLSearchParams();
        params.append('page',  page.toString());
        params.append('inicio',  inicio);
        params.append('final',  final);

        const { data } = await gastosApi.get('/todos', { params });
        useGastosStore.setState({ totalGastos : data.total });
        return data.data;
    } catch (error) {
        const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
        Swal.fire('Error', errores, 'error');
        return false;
    }
}




export const recalcularGastosCaja = async({ inicio, final, }) => {
    try {
        const params = new URLSearchParams();
        params.append('inicio',  inicio);
        params.append('final',  final);

        const { data } = await gastosApi.get(`/recalcular/caja/gastos`, { params });
        return data.data;
    } catch (error) {
        const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
        Swal.fire('Error', errores, 'error');
        return false;
    }
}




export const crearGastoFactura = async(body) => {
    try {
        // const formData = new FormData();
        // if (producto?.img && typeof producto?.img !== 'string') {
        //     formData.append('images', producto.img);
        // }

        // Object.entries(producto).forEach(([key, value]) => {
        //     const valorFormateado = (value !== null && typeof value === "object") ? JSON.stringify(value) : String(value ?? '');
        //     formData.append(key, valorFormateado);
        // });

        await gastosApi.post(`/new`, body);
        Swal.fire('Exitoso', 'Gasto Creado', 'success');
        return true;
    } catch (error) {
        const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
        Swal.fire('Error', errores, 'error');
        return false;
    }
}